import { render, staticRenderFns } from "./SellerDetail.vue?vue&type=template&id=0e2a334f&scoped=true&"
import script from "./SellerDetail.vue?vue&type=script&lang=js&"
export * from "./SellerDetail.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/SalesManagement/SalesManagementSellerDetail/SellerDetailStyle.css?vue&type=style&index=0&id=0e2a334f&scoped=true&lang=css&"
import style1 from "./SellerDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2a334f",
  null
  
)

export default component.exports